import { MandatoryTextField, MandatoryEmail, TokenRule, MandatorySelect } from "@/utils/input-rules"

export const rules = {
  text: MandatoryTextField,
  email: MandatoryEmail,
  token: TokenRule,
  select: MandatorySelect
}
